import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';

const Confirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderId = location.state?.orderId || 'N/A';

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center">
        {/* Success Icon */}
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, type: "spring" }}
          className="w-20 h-20 mx-auto mb-8 border border-white/20 rounded-full flex items-center justify-center"
        >
          <Check className="w-10 h-10 text-white" />
        </motion.div>

        {/* Title */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="font-serif text-3xl sm:text-4xl text-zinc-50 mb-4"
        >
          Order Confirmed
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="font-sans text-base text-zinc-400 mb-8"
        >
          Thank you for your order. Your formulations will be prepared and shipped with the utmost care and discretion.
        </motion.p>

        {/* Order ID */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="bg-[#0A0A0A] border border-white/5 p-6 mb-8"
        >
          <p className="font-sans text-xs tracking-[0.2em] uppercase text-zinc-500 mb-2">
            Order Reference
          </p>
          <p 
            data-testid="order-id"
            className="font-mono text-lg text-zinc-50"
          >
            {orderId.slice(0, 8).toUpperCase()}
          </p>
        </motion.div>

        {/* Priority Access Message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="mb-12"
        >
          <div className="w-px h-8 bg-zinc-700 mx-auto mb-6" />
          <p className="font-serif text-xl text-zinc-300 italic">
            "You now have priority access to future formulations."
          </p>
        </motion.div>

        {/* Continue Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
        >
          <button
            data-testid="continue-button"
            onClick={() => navigate('/collection')}
            className="inline-flex items-center gap-3 bg-white text-black px-8 py-4 font-sans text-xs font-medium tracking-[0.2em] uppercase hover:bg-zinc-200 transition-all duration-300"
          >
            Continue Exploring
            <ArrowRight className="w-4 h-4" />
          </button>
        </motion.div>

        {/* Footer Note */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="mt-12 font-sans text-xs text-zinc-600"
        >
          A confirmation email has been sent to your registered address.
        </motion.p>
      </div>
    </div>
  );
};

export default Confirmation;
